// Simple client-side ad moderation utility
// Note: For production, replace with a server-side or Cloud Function moderation pipeline.

export type ScanResult = 'clean' | 'suspicious' | 'blocked';

export interface AdScan {
  result: ScanResult;
  reasons: string[];
}

const blockedTerms = [
  'porn', 'pornography', 'xxx', 'nsfw', 'nude', 'sex', 'escort', 'incest',
  'hate', 'racist', 'terror', 'terrorist', 'isis', 'bomb', 'kill', 'murder',
  'weapon', 'guns for sale', 'drugs', 'cocaine', 'heroin', 'meth', 'weed',
  'counterfeit', 'fake id', 'scam', 'get rich quick', 'mlm', 'pyramid scheme',
  'gambling', 'casino', 'bet now', 'sports betting'
];

const suspiciousTerms = [
  'free money', '100% guarantee', 'no risk', 'limited time', 'click here',
  'weight loss', 'supplement', 'loan', 'credit fix', 'crypto', 'bitcoin',
  'forex', 'adult', 'dating'
];

const testText = (text: string | undefined | null): string[] => {
  if (!text) return [];
  const t = text.toLowerCase();
  const reasons: string[] = [];
  for (const term of blockedTerms) {
    if (t.includes(term)) reasons.push(`blocked_term:${term}`);
  }
  for (const term of suspiciousTerms) {
    if (t.includes(term)) reasons.push(`suspicious_term:${term}`);
  }
  return reasons;
};

export const aiScanAd = async (input: { title: string; description: string; targetURL?: string; imageURL?: string; videoURL?: string; }): Promise<AdScan> => {
  const reasons = [
    ...testText(input.title),
    ...testText(input.description),
    ...(input.targetURL ? testText(input.targetURL) : [])
  ];
  // Basic heuristic: any blocked_term => blocked; if any suspicious_term and no blocked => suspicious; else clean
  if (reasons.some(r => r.startsWith('blocked_term:'))) {
    return { result: 'blocked', reasons };
  }
  if (reasons.some(r => r.startsWith('suspicious_term:'))) {
    return { result: 'suspicious', reasons };
  }
  return { result: 'clean', reasons };
};
